import './sw-cms-el-acris-blog-content.scss';

const { Mixin } = Shopware;

/**
 * @private
 * @sw-package discovery
 */
export default {
    mixins: [
        Mixin.getByName('cms-element'),
    ],

    computed: {
        isBlogPage() {
            return this.cmsPageState?.currentPage?.type ?? '' === 'cms_blog';
        },
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-content');

            if (this.isBlogPage && !this.element?.translated?.config?.content) {
                this.element.config.content.source = 'mapped';
                this.element.config.content.value = 'acris_blog.content';
            }
            this.updateDemoValue();
        },

        updateDemoValue() {
            if (this.element.config.content.source === 'mapped') {
                let label = '';
                let className = 'sw-cms-el-acris-blog-content__skeleton';

                if (this.element.config.content.value === 'acris_blog.content') {
                    className = 'sw-cms-el-acris-blog-content__placeholder';
                    label = this.$tc('acris-blog.elements.blogContent.preview.content');
                }

                this.demoValue = `<p class="${className}">${label}</p>`;

                if (this.cmsPageState.currentDemoEntity) {
                    this.demoValue = this.getDemoValue(this.element.config.content.value);
                }
            }
        },
    },
};
